<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { HStack, VStack, Spacer } from "../component/layout";
  import { trim, capitalize, uppercase } from "../utils.js";
  import { load, add, loadGroup, updateGroup, deleteGuest as del } from "../guest.js";
  import { loadGuest, loadInvitation } from "../labels.js";
  import { Icon, Button, Label, Hamburger, Sidebar, Text } from "../component/widget";
  import GuestForm from "../component/GuestForm.svelte";
  import GuestLabels from "../component/GuestLabels.svelte";
  import { AGE_LABEL } from "../dico.js";

  export let invitation_id;
  export let group;
  export let wedding_guid;
  export let isOpened = false;
  export let search;

  let cell;
  let name = group[0].name;
  let groupWithLabels = group;
  let labels;
  let isAddGuest = false;
  let isEditInvitation = false;
  let guestId = null;
  let firstName = null;
  let lastName = null;
  let email = null;
  let age = "A";
  let age_val = null;
  let gender = "F";
  let attending = null;
  let food_restriction = null;
  let favorite_songs = null;

  let hamburger;

  function cookHamburgers(group) {
    if (group) {
      let h = [];
      h.push({ display: false, opened: false });
      for (const g of group) {
        h.push({ display: false, opened: false });
      }
      hamburger = h;
    }
  }

  $: cookHamburgers(group);

  function getTooltipAge(g) {
    return `${AGE_LABEL[g.age]}` + (g.age_val ? ` (${g.age_val} ans)` : "");
  }

  const dispatch = createEventDispatcher();

  const submitInvitation = async () => {
    try {
      await updateGroup(wedding_guid, invitation_id, name);
      group = await loadGroup(wedding_guid, invitation_id);
      await loadGroupWithLabels();
      isEditInvitation = false;
    } catch (e) {
      console.log(e);
    }
  };
  const cancelEditInvitation = (e) => {
    isEditInvitation = false;
  };

  const submit = async (
    firstname,
    lastname,
    email,
    age,
    gender,
    guestId,
    attending,
    food_restriction,
    favorite_songs,
    age_val
  ) => {
    await add(
      wedding_guid,
      invitation_id,
      guestId,
      firstname,
      lastname,
      email,
      age,
      gender,
      attending,
      food_restriction,
      favorite_songs,
      age_val
    );
    dispatch("refresh_count");
    isAddGuest = false;
    group = await loadGroup(wedding_guid, invitation_id);
    await loadGroupWithLabels();
  };

  const cancel = () => {
    isAddGuest = false;
  };

  const delGuest = async (guest_id) => {
    try {
      await del(wedding_guid, invitation_id, guest_id);
      group = await loadGroup(wedding_guid, invitation_id);
      if (group.length === 0) {
        dispatch("refresh");
      } else {
        dispatch("refresh_count");
        await loadGroupWithLabels();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const addGuest = () => {
    firstName = null;
    lastName = group[0].lastname;
    email = null;
    age = "A";
    gender = "F";
    guestId = null;
    attending = null;
    food_restriction = null;
    favorite_songs = null;
    isAddGuest = true;
    age_val = null;
  };

  const editGuest = (guest_id, i) => {
    let g = group.find((g) => g.id == guest_id);
    firstName = g.firstname;
    lastName = g.lastname;
    email = g.email;
    age = g.age;
    gender = g.gender;
    attending = g.is_attending === "1" ? "O" : g.is_attending === "0" ? "N" : null;
    food_restriction = g.food_restriction;
    favorite_songs = g.favorite_songs;
    guestId = g.id;
    isAddGuest = true;
    hamburger[i].opened = false;
    age_val = g.age_val;
  };

  const editInvitation = (e, invitation_id) => {
    e.stopPropagation();
    isEditInvitation = true;
    hamburger[0].opened = false;
  };

  const handleInvitationLabels = (e, invitation_id) => {
    e.stopPropagation();
    handleLabels(invitation_id, 0, false);
  };

  const handleLabels = (guest_id, i, isGuest = true) => {
    labels = new GuestLabels({
      target: document.querySelector("body"),
      props: {
        guestId: guest_id,
        isGuest: isGuest,
      },
    });
    const off = labels.$on("close", (event) => {
      off();
      labels.$destroy();
    });

    labels.$on("refresh", (event) => {
      loadGroupWithLabels();
    });
    hamburger[i].opened = false;
  };

  const loadLabelForGroup = async (group) => {
    group[0].groupLabels = await loadInvitation(group[0].invitation_id);
  };

  const loadLabelsForGuest = async (guest) => {
    guest.labels = await loadGuest(guest.id);
  };

  const loadGroupWithLabels = async () => {
    loadLabelForGroup(group);
    for (const g of group) {
      await loadLabelsForGuest(g);
    }
    groupWithLabels = group;
    //console.log(groupWithLabels);
  };

  const countInGroup = (group, attr) => {
    return group.filter((g) => g[attr]).length;
  };

  const countValueInGroup = (group, attr, value) => {
    return group.filter((g) => g[attr] == value).length;
  };

  onMount(() => {
    if (isOpened) {
      cell.scrollIntoView();
    }
  });
</script>

<section
  bind:this={cell}
  class="group"
  class:opened={isOpened}
  on:mouseenter={() => (hamburger[0].display = true)}
  on:mouseleave={() => (hamburger[0].display = false)}>
  {#if isEditInvitation}
    <form on:submit|preventDefault={submitInvitation}>
      <HStack>
        <Text
          id={"name"}
          reset
          required
          bind:value={name}
          fa={false}
          icon="images/family-restroom.svg"
          label="Famille"
          placeholder="Famille Dupond" />
        <button class="cancel" type="button" on:click={cancelEditInvitation}>
          <i class="fas fa-angle-double-left" />
          <span>Annuler</span>
        </button>
        <button class="primary" type="submit">
          <i class="fas fa-edit" />
          <span>Modifier</span>
        </button>
      </HStack>
    </form>
  {:else}
    {#if group.length}
      <Button action={() => (isOpened = !isOpened)}>
        <HStack alignment="stretch" grow>
          <span class="group">
            <Label
              icon="images/family-restroom.svg"
              fa={false}
              text={group[0].name}
              h="auto"
              selection={search} />
          </span>
          {#if groupWithLabels && groupWithLabels[0]}
            {#if groupWithLabels[0].groupLabels && groupWithLabels[0].groupLabels.length > 3}
              {#each groupWithLabels[0].groupLabels.slice(0, 3) as l (l.id)}
                <span class="label">
                  <Label text={l.name} icon="tag" />
                </span>
              {/each}
              <span class="label">
                <Button action={(e) => handleInvitationLabels(e, groupWithLabels[0].invitation_id)}>
                  <Label text="..." icon="tag" />
                </Button>
              </span>
            {:else}
              {#each groupWithLabels[0].groupLabels || [] as l (l.id)}
                <span class="label">
                  <Label text={l.name} icon="tag" />
                </span>
              {/each}
            {/if}
          {/if}
          {#if !isOpened}
            {#if countInGroup(group, "email") > 0}
              <span class="count-group">
                <Label
                  text={countInGroup(group, "email") + " x"}
                  icon="envelope"
                  iconLeft={false} />
              </span>
            {/if}
            {#if countValueInGroup(group, "age", "A") > 0}
              <span class="count-group">
                <Label
                  text={countValueInGroup(group, "age", "A") + " x"}
                  icon="restroom"
                  iconLeft={false} />
              </span>
            {/if}
            {#if countValueInGroup(group, "age", "T") > 0}
              <span class="count-group">
                <Label
                  text={countValueInGroup(group, "age", "T") + " x"}
                  fa={false}
                  icon="images/cap.svg"
                  iconLeft={false} />
              </span>
            {/if}
            {#if countValueInGroup(group, "age", "C") > 0}
              <span class="count-group">
                <Label
                  text={countValueInGroup(group, "age", "C") + " x"}
                  icon="child"
                  iconLeft={false} />
              </span>
            {/if}
            {#if countValueInGroup(group, "age", "B") > 0}
              <span class="count-group">
                <Label
                  text={countValueInGroup(group, "age", "B") + " x"}
                  icon="baby"
                  iconLeft={false} />
              </span>
            {/if}
          {/if}

          <Hamburger bind:open={hamburger[0].opened} display={hamburger[0].display} left={false}>
            <Button action={(e) => editInvitation(e, group[0].invitation_id)}>
              <Label text="Editer" icon="edit" h="24px" />
            </Button>
            <Button action={(e) => handleInvitationLabels(e, group[0].invitation_id)}>
              <Label text="Gérer les labels" icon="tag" h="24px" />
            </Button>
          </Hamburger>
          <Spacer />

          {#if isOpened}
            <Label icon="chevron-up" h="48px" />
          {:else}
            <Label icon="chevron-down" h="48px" />
          {/if}
        </HStack>
      </Button>
    {/if}
    <ul class:opened={isOpened}>
      <VStack>
        {#each groupWithLabels as g, i (g.id)}
          <section
            class="member"
            on:mouseenter={() => (hamburger[i + 1].display = true)}
            on:mouseleave={() => (hamburger[i + 1].display = false)}>
            <HStack alignment="flex-start" grow>
              <span class="name">
                {#if g.age == "A"}
                  {#if g.gender == "F"}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      tooltip={getTooltipAge(g)}
                      selection={search}
                      nowrap
                      size="18"
                      icon="female"
                      iconColor="#FF005C" />
                  {:else}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      tooltip={getTooltipAge(g)}
                      selection={search}
                      nowrap
                      size="18"
                      icon="male" />
                  {/if}
                {:else if g.age == "T"}
                  {#if g.gender == "F"}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      selection={search}
                      tooltip={getTooltipAge(g)}
                      nowrap
                      size="18"
                      fa={false}
                      icon="images/cap_pink.svg"
                      iconColor="#FF005C" />
                  {:else}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      selection={search}
                      tooltip={getTooltipAge(g)}
                      nowrap
                      size="18"
                      fa={false}
                      icon="images/cap.svg" />
                  {/if}
                {:else if g.age == "C"}
                  {#if g.gender == "F"}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      selection={search}
                      tooltip={getTooltipAge(g)}
                      nowrap
                      size="18"
                      icon="child"
                      iconColor="#FF005C" />
                  {:else}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      selection={search}
                      tooltip={getTooltipAge(g)}
                      nowrap
                      size="18"
                      icon="child" />
                  {/if}
                {:else if g.age == "B"}
                  {#if g.gender == "F"}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      selection={search}
                      tooltip={getTooltipAge(g)}
                      nowrap
                      size="18"
                      icon="baby"
                      iconColor="#FF005C" />
                  {:else}
                    <Label
                      text="{g.firstname}
                      {g.lastname}"
                      selection={search}
                      tooltip={getTooltipAge(g)}
                      nowrap
                      size="18"
                      icon="baby" />
                  {/if}
                {/if}
              </span>
              <span class="email">
                <Label
                  text={g.email}
                  selection={search}
                  icon="envelope"
                  tooltip={g.email ? false : "aucun email"} />
              </span>
              {#if g.is_attending}
                <span
                  class:attending={g.is_attending === "1"}
                  class:not_attending={g.is_attending === "0"}>
                  <Label
                    text={g.is_attending === "1" ? "OUI" : "NON"}
                    selection={search}
                    icon="glass-cheers"
                    color="inherit"
                    iconColor="inherit" />
                </span>
              {/if}
              {#if g.food_restriction}
                <span class="label">
                  <Label icon="utensils" tooltip={g.food_restriction} />
                </span>
              {/if}
              {#if g.favorite_songs}
                <span class="label">
                  <Label icon="music" tooltip={g.favorite_songs} />
                </span>
              {/if}
              {#if g.labels.length > 3}
                {#each g.labels.slice(0, 3) as l (l.id)}
                  <span class="label">
                    <Button action={(e) => handleLabels(g.id, i + 1)}>
                      <Label text={l.name} icon="tag" />
                    </Button>
                  </span>
                {/each}
                <span class="label">
                  <Button action={(e) => handleLabels(g.id, i + 1)}>
                    <Label text="..." icon="tag" />
                  </Button>
                </span>
              {:else}
                {#each g.labels as l (l.id)}
                  <span class="label">
                    <Button action={(e) => handleLabels(g.id, i + 1)}>
                      <Label text={l.name} icon="tag" />
                    </Button>
                  </span>
                {/each}
              {/if}
              <Hamburger
                bind:open={hamburger[i + 1].opened}
                display={hamburger[i + 1].display}
                left={false}>
                <Button action={() => editGuest(g.id, i + 1)}>
                  <Label text="Editer" icon="edit" h="24px" />
                </Button>
                <Button action={() => handleLabels(g.id, i + 1)}>
                  <Label text="Gérer les labels" icon="tag" h="24px" />
                </Button>
                <Button action={() => delGuest(g.id)}>
                  <Label text="Supprimer" icon="times-circle" h="24px" />
                </Button>
              </Hamburger>
              <Spacer />
            </HStack>
          </section>
        {/each}
        {#if !isAddGuest}
          <div class="actions">
            <Button action={addGuest}>
              <Label text="Ajouter un membre à la famille" icon="user-plus" h="48px" />
            </Button>
          </div>
        {/if}

        <GuestForm
          {submit}
          {cancel}
          bind:show={isAddGuest}
          bind:guestId
          bind:firstName
          bind:lastName
          bind:email
          bind:age
          bind:age_val
          bind:gender
          showAttending={guestId}
          attendindRequired={false}
          bind:attending
          showFoodRestriction={guestId}
          bind:food_restriction
          showFavoriteSongs={guestId}
          bind:favorite_songs
          placeholder={"Email (si différent de l’email principal)"} />
      </VStack>
    </ul>
  {/if}
</section>

<style>
  section.group {
    line-height: 3em;
    border: 1px solid var(--primary-color);
    border-radius: 5px;
    padding-top: 5px;
    margin-bottom: 5px;
    height: 45px;
  }
  section.group.opened {
    height: auto;
  }

  section.group:nth-child(even) {
    background-color: #edf4f9;
  }

  section.member:hover {
    background-color: rgb(244, 245, 247);
    color: rgb(23, 43, 77);
  }

  span.name {
    line-height: 1em;
    border-radius: 15px;
    background-color: #b8c5d0;
    padding: 0.5em;
    margin-bottom: 5px;
    margin-right: 1em;
  }

  span.email {
    line-height: 1em;
    border-radius: 15px;
    background-color: #b8c5d0;
    padding: 0.5em;
    margin-bottom: 5px;
    margin-right: 1em;
  }

  span.attending {
    line-height: 1em;
    border-radius: 15px;
    background-color: var(--primary-light-color);
    color: var(--on-primary-color);
    padding: 0.5em;
    margin-bottom: 5px;
    margin-right: 1em;
  }
  span.not_attending {
    line-height: 1em;
    border-radius: 15px;
    background-color: var(--error-color);
    color: var(--on-error-color);
    padding: 0.5em;
    margin-bottom: 5px;
    margin-right: 1em;
  }

  span.count-group {
    line-height: 1em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    margin-bottom: 5px;
  }
  span.group {
    line-height: 1em;
    align-self: stretch;
  }
  span.group > :global(article) {
    padding: 0.5em;
  }

  span.label {
    line-height: 1em;
    margin-bottom: 5px;
    align-self: stretch;
    margin-left: 1px;
  }

  span.label :global(article) {
    border-radius: 15px;
    background-color: var(--secondary-light-color);
    padding: 0.5em;
  }

  ul {
    list-style-type: none;
    margin: 0;
    transform: scaleY(0);
    transform-origin: 50% 0;
    transition: none;
  }

  ul.opened {
    transform: scaleY(1);
    transition: transform 0.5s ease-out;
  }

  form {
    width: fit-content;
    margin-left: 5px;
  }
  button {
    margin-left: 1em;
  }
</style>
